<template>

    <div class="canvas-menu">
        <div class="maintitle d-flex align-items-center"> 
            <div class="leftbarIcon" @click="$emit('toggleSidebar')"><span></span><span></span><span></span></div>
            <span class="logotext">PAMS</span>
        </div>
        <div class="sideNav">
           
            <div class="listItem">
                <menu-list mobile></menu-list>
            </div>
        </div>
       
        
    </div>

</template>

<script>
import Logo from "@/components/layout/shared/logo";
import MenuList from "@/components/layout/dashboard/menu/menu-list";

export default {
    name: "sidebar",
    components: {MenuList, Logo},
    
    watch: {
       
    },
    data() {
        return {
            showMenu: false
        }
    },
    methods: {
        toggleSidebar(force = null) {
            // if (force !== null) {
            //     this.sidebarVisible = force;
            // } else {
            //     this.sidebarVisible = !this.sidebarVisible;
            // }
            this.isActive = !this.isActive
        },
    }
}
</script>
